
import Page from 'page';
import ProfileController from '../controllers/profileController';
import AddressController from '../controllers/addressController';

import {
    CLOSE_SITE_NAV
} from '../../../core/js/actions/headerActions';
import { setupRoutes } from '../utils/routerUtils';

window.page = Page;
const page = window.page;

// HeaderController.render();
export function initRouter(store) {
    const urlsRequireTrailingSlash = _.get(store, 'core.constants.urlsRequireTrailingSlash', false);
    const contextPath = _.get(store, 'core.contextPath', '/');
    const routeBase = `${contextPath}account`;

    const routes = {
        '/address': address,
        '/account-settings': accountSettings
    };

    const options = {
        'requireTrailingSlash': urlsRequireTrailingSlash,
        'redirectToTrailingSlash': urlsRequireTrailingSlash
    };

    setupRoutes(page, routeBase, routes, options);

    function address() {
        // let returnedRouter = returnRouter();
        AddressController.render(store);
        const routeTitle = _.get(
            store,
            'core.localizations.containers.chromeLocalization.account_navigation-addressAndPayments',
            'My Account'
        );
        setPageTitle(store, routeTitle);
        handleBurgerNavTouch(store);
    }

    function accountSettings() {
        try {
            ProfileController.render(store);
            ProfileController.postRender(store);
            const routeTitle = _.get(
                store,
                'core.localizations.containers.chromeLocalization.account_navigation-accountSettings',
                'My Account'
            );
            setPageTitle(store, routeTitle);
            handleBurgerNavTouch(store);
        } catch(e) {
            console.error(e);
        }
    }

    /**
     * Makes sure the mobile nav closes when navigating between account pages
     * @param  {object} store The current state of the redux store
     * @return {undefined}    Returns nothing
     */
    // eslint-disable-next-line no-shadow
    function handleBurgerNavTouch(store) {
        const deviceCharacteristics = store.core.deviceCharacteristics;
        if(deviceCharacteristics.is_smallish || deviceCharacteristics.is_tablet || window.innerWidth < 768) {
            $.event.trigger({
                type: CLOSE_SITE_NAV
            });
        }
    }

    page();

}

/**
 * Utility function for setting the title of a page based on the current route
 * @param {object} store The current state of the redux store
 * @param {string} routeTitle localized title of the current account section
 */
function setPageTitle(store, routeTitle) {
    document.title = `${routeTitle} | ${store.core.constants.siteName}`;
}
